import React from "react";
import { Link } from "react-router-dom";
import { Taxi, MapTrifold, Lightning, ShieldCheck } from "@phosphor-icons/react";

export default function Landing() {
  return (
    <div className="min-h-screen" style={{ background: "linear-gradient(180deg,#0F172A 0%,#1E293B 100%)" }}>
      <nav className="px-6 py-5 flex items-center justify-between max-w-7xl mx-auto">
        <div className="flex items-center gap-3 text-white">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: "var(--primary)" }}>
            <Taxi size={22} color="white" weight="duotone" />
          </div>
          <span className="text-xl font-black font-display">TAXI AD2</span>
        </div>
        <div className="flex gap-3">
          <Link to="/login" data-testid="nav-login-btn">
            <button className="text-white px-4 py-2 font-semibold hover:bg-white/10 rounded-lg transition">Iniciar sesión</button>
          </Link>
          <Link to="/register" data-testid="nav-register-btn">
            <button className="btn-primary">Empezar</button>
          </Link>
        </div>
      </nav>

      <section className="px-6 py-16 max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center">
        <div className="text-white fade-in">
          <div className="pill pill-info mb-6 inline-flex" style={{ background: "rgba(255,69,0,0.15)", color: "#F5B700" }}>
            <Lightning weight="fill" size={14} /> Localización GPS en tiempo real
          </div>
          <h1 className="text-5xl md:text-6xl font-black font-display leading-[1.05] tracking-tight">
            Un taxi cerca<br/>de <span style={{ color: "var(--primary)" }}>ti</span>.
          </h1>
          <p className="text-slate-300 text-lg mt-6 leading-relaxed max-w-md">
            Localiza taxis que están a tu alrededor y no ves. Viaja sabiendo el coste de tu viaje al solicitar el taxi.
          </p>
          <div className="flex gap-4 mt-8">
            <Link to="/register"><button className="btn-primary text-lg px-7" data-testid="hero-cta-btn">Crear cuenta</button></Link>
            <Link to="/login"><button className="btn-primary text-lg px-7">Ya tengo cuenta</button></Link>
          </div>
        </div>
        <div className="relative h-[420px] rounded-3xl overflow-hidden border border-white/10 shadow-2xl">
          <img src="https://images.unsplash.com/photo-1494488180300-4c634d1b2124?w=900&q=80" alt="city" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-transparent to-transparent" />
          <div className="absolute bottom-6 left-6 right-6 glass rounded-2xl p-4 flex items-center gap-3">
            <div className="dot-pulse" />
            <span className="font-bold text-sm">Conductores conectados ahora</span>
          </div>
        </div>
      </section>

      <section className="px-6 py-16 max-w-7xl mx-auto grid md:grid-cols-3 gap-6">
        {[
          { id: "tracking", icon: <MapTrifold size={28} weight="duotone" />, title: "Tracking en vivo", desc: "WebSockets + Leaflet/OpenStreetMap. Sin claves de Google." },
          { id: "roles", icon: <Lightning size={28} weight="duotone" />, title: "Como quieres acceder", desc: "Conductor o Pasajero." },
          { id: "host", icon: <ShieldCheck size={28} weight="duotone" />, title: "Libertad e Independencia", desc: "La revolución del taxi en la palma de tu mano." },
        ].map((f) => (
          <div key={f.id} className="card glass" style={{ background: "rgba(255,255,255,0.05)", borderColor: "rgba(255,255,255,0.1)", color: "white" }}>
            <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-4" style={{ background: "rgba(255,69,0,0.15)", color: "#F5B700" }}>
              {f.icon}
            </div>
            <h3 className="font-display font-bold text-xl">{f.title}</h3>
            <p className="text-slate-300 text-sm mt-2">{f.desc}</p>
          </div>
        ))}
      </section>

      <footer className="text-center py-8 text-slate-500 text-sm">TAXI AD2 · Construido sobre tu servidor</footer>
    </div>
  );
}
